import { LUA_DESKTOP_ANIMATION_DURATION_MS, LUA_MOBILE_ANIMATION_DURATION_MS } from 'constants.js'
import { navBarHeight, playerMobileHeight } from 'styling/theme'

import { interactionNavBarHeight } from 'components/set/InteractionWidget/styles'
import { messagingBannerHeight } from 'components/set/MessagingBanner/styles'

export const styles = () => ({
    '@keyframes oscillate': {
        from: {
            transform: 'translateX(-6px)',
        },
        to: {
            transform: 'translateX(6px)',
        },
    },
    '@keyframes disperse': {
        from: {
            transform: 'translateY(-60px) scale(1)',
            opacity: 0.8,
        },
        to: {
            transform: 'translateY(calc(var(--offset) - var(--travelDistance))) scale(0.6)',
            opacity: 0,
        },
    },
    '@keyframes disperseMobile': {
        '0%': {
            transform: 'translateY(0) scale(1)',
            opacity: 0.8,
        },
        '90%': {
            opacity: 0.4,
        },
        '100%': {
            transform: 'translateY(calc(var(--offset) + 32px + var(--travelDistance) - 100vh)) scale(0.6)',
            opacity: 0,
        },
    },
    luaContainer: {
        '--travelDistance': '600px',
        '--offset': '0px',
        display: 'inline-block',
        animation: `$disperse ${LUA_DESKTOP_ANIMATION_DURATION_MS}ms ease-out`,
        transform: 'translateY(0)',
        willChange: 'transform, opacity',
        backfaceVisibility: 'hidden',
        fontSize: '32px',
        position: 'absolute',
        opacity: 0,

        '&.lua-idle': {
            animation: 'none',
        },

        '@media (max-width: 767px)': {
            '--travelDistance': `${playerMobileHeight}vw + ${navBarHeight}px + ${interactionNavBarHeight}px + ${messagingBannerHeight}px + ${interactionNavBarHeight}px`,
            animationName: '$disperseMobile',
            animationDuration: `${LUA_MOBILE_ANIMATION_DURATION_MS}ms`,
        },
    },
    lua: {
        display: 'inline-block',
        animation: '$oscillate 0.5s infinite alternate ease-in-out',
        position: 'absolute',
        userSelect: 'none',
        willChange: 'transform',
        backfaceVisibility: 'hidden',
        height: 25,
        width: 25,
    },
})
